import { createTheme } from '@mui/material/styles';
import colors from '../styles/colors';


export const DropdownOpenIcon = () => (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L7.20869 9.86956C7.59886 10.4269 8.4197 10.4404 8.82793 9.8961L15.5 1" stroke="#C5C5C5" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const DropdownCloseIcon = () => (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 9.86956L7.20869 1C7.59886 0.44375 8.4197 0.430274 8.82793 1.0L15.5 9.86956" stroke="#C5C5C5" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const primaryButtonStyle = {
    backgroundColor: colors.primary,
    fontSize: 12,
    color: "white",
    borderRadius: "20px",
    padding: "8px 26px",
    textTransform: "none",
    fontFamily: "PMe",
}



const theme = createTheme({
    // components: {
    //     MuiTextField: {
    //         defaultProps: {
    //             InputProps: {
    //                 sx: {
    //                     height: '35px',
    //                     borderRadius: '8px',
    //                     '& .MuiOutlinedInput-notchedOutline': {
    //                         borderColor: '#C1BBEB',
    //                     },
    //                     '&:hover .MuiOutlinedInput-notchedOutline': {
    //                         borderColor: '#C1BBEB',
    //                     },
    //                 },
    //                 style: {
    //                     fontFamily: 'PRe',
    //                     fontSize: '13px',
    //                 },
    //             },
    //             InputLabelProps: {
    //                 style: {
    //                     fontFamily: 'PRe',
    //                 },
    //             },
    //         },
    //         styleOverrides: {
    //             root: {
    //                 '& .MuiOutlinedInput-input': {
    //                     fontFamily: 'PRe',
    //                     fontSize: '13px',
    //                 },
    //             },
    //         },
    //     },

    //     MuiMenuItem: {
    //         styleOverrides: {
    //             root: {
    //                 fontFamily: 'PRe',
    //                 fontSize: '12px',
    //                 color: colors.black,
    //             },
    //         },
    //     },


    // },


    components: {
        MuiTextField: {
            defaultProps: {
                InputProps: {
                    sx: {
                        height: '35px',
                        borderRadius: '8px',
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#C1BBEB',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#C1BBEB',
                        },
                    },
                    style: {
                        fontFamily: 'PRe',
                        fontSize: '13px',
                    },
                },
                InputLabelProps: {
                    style: {
                        fontFamily: 'PRe',
                    },
                },
            },
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-input': {
                        fontFamily: 'PRe',
                        fontSize: '13px',
                    },
                },
            },
        },

        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontFamily: 'PRe',
                    fontSize: '12px',
                    color: colors.black,
                },
            },
        },

        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    // Custom styling for the Autocomplete root
                    '& .MuiAutocomplete-inputRoot': {
                        height: '35px', // Control the height of the input
                        borderRadius: '8px', // Border radius for the input field
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#C1BBEB', // Outline color when not focused
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#C1BBEB', // Outline color on hover
                        },
                    },
                },
                input: {
                    fontFamily: 'PRe',
                    fontSize: '13px',
                },
                popper: {
                    // Custom styles for the dropdown (popper)
                    '& .MuiAutocomplete-paper': {
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                        padding: '8px 0',
                    },
                },
                listbox: {
                    '& .MuiAutocomplete-option': {
                        fontFamily: 'PRe',
                        fontSize: '11px',
                        color: colors.textPrimary, // Text color for options
                        '&:hover': {
                            backgroundColor: '#f1f1f1', // Highlight on hover
                        },
                    },
                },

            },
        },




    },
});


export default theme;
